module.exports = __webpack_public_path__ + "static/media/check.62d922c1.svg";